import { Texture } from "@pixi/core";
import { IDestroyOptions } from "@pixi/display";
import { Event } from "event-system";
import { Button } from "ui-pixijs";
import { AudioManager } from "../../../audio/AudioManager";
import { AudioNames } from "../../../audio/AudioNames";

export class ToggleButton extends Button {
    public readonly onChange: Event<boolean> = new Event<boolean>();

    public constructor(
        private readonly onTexture: Texture,
        private readonly offTexture: Texture,
        private isOn: boolean,
        private readonly audioManager: AudioManager
    ) {
        super({ defaultTexture: isOn ? onTexture : offTexture });
        this.onUp.add(this.onUpToggleButton, this);
    }

    private onUpToggleButton(): void {
        this.isOn = !this.isOn;
        this.audioManager.play(AudioNames.Click);
        this.defaultView.texture = this.isOn ? this.onTexture : this.offTexture;
        this.onChange.emit(this.isOn);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.onUpToggleButton, this);
        super.destroy(options);
    }
}